// ----------------------------------------------------------------------
import styles from './BrandOwner.module.css';
import { NavLink as RouterLink } from 'react-router-dom';
import { useNavigate } from 'react-router-dom';
import Filter1 from '../Filter/Filter1';
import { Card, Avatar } from '@mui/material';
import Scrollbar from '../../components/scrollbar';
// sections
// mock
import { styled } from '@mui/material/styles';
import Tooltip, { tooltipClasses } from '@mui/material/Tooltip';
import { useEffect, useState } from 'react';

//Carousel
import Slider from 'react-slick';
import 'slick-carousel/slick/slick.css';
import 'slick-carousel/slick/slick-theme.css';
import { Typography } from '@mui/material';

import axiosInstance from 'src/axiosInstance';
import toast from 'react-hot-toast';
import bus from 'src/bus';
import moment from 'moment';
import { BallTriangle } from 'react-loader-spinner';
import { shortenText } from 'src/utils';

// ----------------------------------------------------------------------

const TABLE_HEAD = [
  { id: 'customerName', label: 'Customers', alignRight: false },
  { id: 'orderNumber', label: 'Order Number', alignRight: false },
  { id: 'productPurchased', label: 'Product Purchased', alignRight: false },
  { id: 'customerLocation', label: 'Location', alignRight: false },
  // { id: 'price', label: 'Total cost', alignRight: false },
  { id: 'status', label: 'Status', alignRight: false },
  { id: 'created_at', label: 'Date ordered', alignRight: false },
];
const BootstrapTooltip = styled(({ className, ...props }) => (
  <Tooltip {...props} arrow classes={{ popper: className }} />
))(({ theme }) => ({
  [`& .${tooltipClasses.arrow}`]: {
    color: theme.palette.common.black,
  },
  [`& .${tooltipClasses.tooltip}`]: {
    backgroundColor: theme.palette.common.black,
  },
}));

export default function DashboardAppPage() {
  const navigate = useNavigate();
  const [isPending, setIsPending] = useState(false);
  const [searchvalue, setSearchValue] = useState('');
  const notifyError = (err) => toast.error(err);
  const notify = (msg) => toast.success(msg);
  const [tooltipData, setToolTipData] = useState({ product_items: [] });
  const [tooltipLoading, setToolTipLoading] = useState(false);

  const [dataFilter, setDataFilter] = useState('today');
  const [dashboardData, setDashboardData] = useState({
    totalSales: 0,
    totalOrders: 0,
    totalProducts: 0,
    totalCustomers: 0,
    salesData: [],
    orderData: [],
    productData: [],
    customerData: [],
    banner: null, // Add banner field
    bannerLoading: true, // Add banner loading state
  });

  // for carousel
  const settings = {
    dots: false,
    infinite: true,
    speed: 500,
    slidesToShow: 1,
    slidesToScroll: 1,
    autoplay: true, // Enable autoplay
    autoplaySpeed: 2000,
    fade: true,
    scrollBar: false,
  };

  function navigateTo() {
    navigate('/app/orders');
  }

  const handleViewClick = (val) => {
    localStorage.setItem('orders_info', JSON.stringify(val));
    bus.emit('getOrders');
    navigate('/app/order_details_brand');
    // handle view click action
  };

  // const getHoverProduct = (id) => {
  //   setToolTipLoading(true);
  //   setToolTipData({ product_items: [] })
  //   axiosInstance.get(`/brand/order/on-hover/${id}`)
  //     .then(res => {
  //       setToolTipData(res.data.data[0] || { product_items: [] })

  //     }).catch(err => {

  //       try {
  //         notifyError(err.response.data.message);

  //       } catch (error) {
  //         notifyError("Unable to fetch data, try again later");

  //       }

  //     }).finally(() => setToolTipLoading(false))
  // };

  const getHoverProduct = (id) => {
    setToolTipLoading(true);
    setToolTipData({ product_items: [] });
    axiosInstance
      .get(`/brand/sales/shoppers/on-hover/${id}`)
      .then((res) => {
        setToolTipData(res.data.data[0] || { product_items: [] });
      })
      .catch((err) => {
        try {
          notifyError(err.response.data.message);
        } catch (error) {
          notifyError('Something went wrong , please try again later');
        }
      })
      .finally(() => setToolTipLoading(false));
  };

  const handleSendReminderClick = (val) => {
    // handle send reminder click action
    axiosInstance
      .get('/brand/order/send-reminder/' + val)
      .then((res) => {
        notify(res.data.message);
      })
      .catch((err) => {
        try {
          notifyError(err.response.data.message);
        } catch {
          notifyError('Something went wrong, Please try again later');
        }
      });
  };

  const fetchData = (
    page = 1,
    pageSize = 10,
    search = searchvalue,
    dateFilter = dataFilter
  ) => {
    setIsPending(true);
    axiosInstance
      .get('/brand/dashboard/get?', {
        params: {
          page,
          pageSize,
          search,
          dateFilter,
        },
      })
      .then((res) => {
        setDashboardData(res.data.data);
        // setReload(!reload)
      })
      .catch((err) => {
        try {
          notifyError(err.response.data.message);
        } catch (error) {
          notifyError(
            'Unable to fetch dashboard records, please try again later'
          );
        }
      })
      .finally(() => setIsPending(false));
  };

  const fetchBanner = async () => {
    try {
      setDashboardData((prev) => ({ ...prev, bannerLoading: true }));
      
      // First try to get banner from backend
      const backendResponse = await axiosInstance.get('/brand/dashboard/get-banner');
      
      if (backendResponse.status < 300 && backendResponse.data.data) {
        const bannerUrl = backendResponse.data.data;
        console.log('Banner fetched from backend:', bannerUrl);
        
        // Update component state
        setDashboardData((prev) => ({ ...prev, banner: bannerUrl, bannerLoading: false }));
        
        // Update auth data to keep it in sync
        const authData = localStorage.getItem('auth');
        if (authData) {
          try {
            const parsedAuth = JSON.parse(authData);
            parsedAuth.business_banner = bannerUrl;
            localStorage.setItem('auth', JSON.stringify(parsedAuth));
            console.log('Updated auth data with banner from backend');
          } catch (error) {
            console.log('Error updating auth data:', error);
          }
        }
        return;
      }
    } catch (error) {
      console.log('Backend banner fetch failed, trying localStorage:', error);
    }
    
    // Fallback to localStorage if backend fails
    try {
      const authData = localStorage.getItem('auth');
      if (authData) {
        const parsedAuth = JSON.parse(authData);
        const bannerUrl = parsedAuth.business_banner;
        console.log('Banner from localStorage:', bannerUrl);
        
        if (bannerUrl) {
          setDashboardData((prev) => ({ ...prev, banner: bannerUrl, bannerLoading: false }));
        } else {
          setDashboardData((prev) => ({ ...prev, banner: null, bannerLoading: false }));
        }
      } else {
        setDashboardData((prev) => ({ ...prev, banner: null, bannerLoading: false }));
      }
    } catch (error) {
      console.log('Error parsing auth data:', error);
      setDashboardData((prev) => ({ ...prev, banner: null, bannerLoading: false }));
    }
  };

  useEffect(() => {
    bus.on('dashboardSearch', (val) => {
      setSearchValue(val);
    });
  }, []);

  useEffect(() => {
    bus.on('dataFilter', (el) => {
      // console.log(el);
      setDataFilter(el);
    });
    fetchData();
    // Fetch banner independently to avoid race conditions
    fetchBanner();
  }, []); // Remove dependencies to avoid unnecessary re-fetches

  // Separate useEffect for banner refresh when needed
  useEffect(() => {
    // Only refresh banner when search or filter changes significantly
    if (searchvalue || dataFilter) {
      // Debounce banner refresh to avoid excessive API calls
      const timeoutId = setTimeout(() => {
        fetchBanner();
      }, 1000);
      
      return () => clearTimeout(timeoutId);
    }
  }, [searchvalue, dataFilter]);

  const handleBannerUpload = (event) => {
    const file = event.target.files[0];
    if (file) {
      uploadBanner(file);
    }
  };

  const uploadBanner = (file) => {
    // Validate file type
    if (!file.type.startsWith('image/')) {
      notifyError('Please select an image file');
      return;
    }

    // Validate file size (max 5MB)
    if (file.size > 5 * 1024 * 1024) {
      notifyError('File size should be less than 5MB');
      return;
    }

    // Show loading state
    setIsPending(true);

    // Create FormData for file upload
    const formData = new FormData();
    formData.append('banner', file);

    // Upload to backend
    axiosInstance
      .post('/brand/dashboard/upload-banner', formData, {
        headers: {
          'Content-Type': 'multipart/form-data',
        },
      })
      .then((res) => {
        if (res.status < 300) {
          // Update state with the banner URL from backend
          // Based on the API response: res.data.data contains the direct URL string
          const bannerUrl = res.data.data;
          console.log('Banner upload response:', res.data);
          console.log('Banner URL extracted:', bannerUrl);
          
          setDashboardData((prev) => ({ ...prev, banner: bannerUrl }));
          
          // Update the auth data in localStorage to keep it in sync
          const authData = localStorage.getItem('auth');
          if (authData) {
            try {
              const parsedAuth = JSON.parse(authData);
              parsedAuth.business_banner = bannerUrl;
              localStorage.setItem('auth', JSON.stringify(parsedAuth));
              console.log('Updated auth data with new banner URL:', bannerUrl);
            } catch (error) {
              console.log('Error updating auth data:', error);
            }
          }
          
          notify('Banner uploaded successfully!');
        }
      })
      .catch((err) => {
        console.error('Banner upload error:', err);
        notifyError(err.response?.data?.message || 'Failed to upload banner. Please try again.');
      })
      .finally(() => {
        setIsPending(false);
      });
  };

  const handleDragOver = (e) => {
    e.preventDefault();
    e.currentTarget.style.borderColor = '#af52de';
    e.currentTarget.style.backgroundColor = '#f8f0ff';
  };

  const handleDragLeave = (e) => {
    e.preventDefault();
    e.currentTarget.style.borderColor = '#ddd';
    e.currentTarget.style.backgroundColor = '#fafafa';
  };

  const handleDrop = (e) => {
    e.preventDefault();
    e.currentTarget.style.borderColor = '#ddd';
    e.currentTarget.style.backgroundColor = '#fafafa';
    
    const files = e.dataTransfer.files;
    if (files.length > 0) {
      uploadBanner(files[0]);
    }
  };

  const handleRemoveBanner = () => {
    // Show loading state
    setIsPending(true);

    // Remove from backend
    axiosInstance
      .delete('/brand/dashboard/remove-banner')
      .then((res) => {
        if (res.status < 300) {
          // Remove from auth data to keep it in sync
          const authData = localStorage.getItem('auth');
          if (authData) {
            try {
              const parsedAuth = JSON.parse(authData);
              delete parsedAuth.business_banner;
              localStorage.setItem('auth', JSON.stringify(parsedAuth));
              console.log('Removed banner from auth data');
            } catch (error) {
              console.log('Error updating auth data:', error);
            }
          }
          
          setDashboardData((prev) => ({ ...prev, banner: null }));
          notify('Banner removed successfully!');
        }
      })
      .catch((err) => {
        console.error('Banner removal error:', err);
        notifyError(err.response?.data?.message || 'Failed to remove banner. Please try again.');
      })
      .finally(() => {
        setIsPending(false);
      });
  };

  return (
    <>
      <style>
        {`
          @keyframes pulse {
            0% { opacity: 1; }
            50% { opacity: 0.5; }
            100% { opacity: 1; }
          }
        `}
      </style>
      <div className={`wrapper mt-md-0 mt-4 px-2`}>
        <div className={`${styles.header} d-block d-md-none mb-4`}>
          <h4 className={`mb-0 pb-0`}>Dashboard</h4>
          <p style={{ fontSize: '14px' }} className={`mb-0 pb-0`}>
            An overview of your business performance
          </p>
        </div>
        {/* Banner Upload */}
        <div style={{ overflow: 'hidden', marginBottom: '20px' }}>
          <div className={`${styles.bannerUpload}`}>
            <div className="d-flex justify-content-between align-items-center mb-3">
              <div>
                <h5 className="mb-1">Dashboard Banner</h5>
                <p className="mb-0" style={{ fontSize: '14px', color: '#666' }}>
                  Upload a custom banner to display on your dashboard
                </p>
              </div>
              <div className="d-flex gap-2">
                {/* <button 
                  className="btn btn-sm btn-outline-secondary"
                  onClick={() => fetchBanner()}
                  disabled={isPending || dashboardData.bannerLoading}
                  title="Refresh banner from server"
                >
                  <svg width="16" height="16" viewBox="0 0 24 24" fill="none" style={{ marginRight: '4px' }}>
                    <path d="M1 4V10H7" stroke="currentColor" strokeWidth="2" strokeLinecap="round" strokeLinejoin="round"/>
                    <path d="M23 20V14H17" stroke="currentColor" strokeWidth="2" strokeLinecap="round" strokeLinejoin="round"/>
                    <path d="M20.49 9A9 9 0 0 0 5.64 5.64L1 10M23 14L18.36 18.36A9 9 0 0 1 3.51 15" stroke="currentColor" strokeWidth="2" strokeLinecap="round" strokeLinejoin="round"/>
                  </svg>
                  Refresh
                </button> */}
                {dashboardData.banner && (
                  <button 
                    className="btn btn-sm btn-outline-danger"
                    onClick={() => handleRemoveBanner()}
                    disabled={isPending}
                  >
                    {isPending ? (
                      <div className="d-flex align-items-center">
                        <div 
                          className="skeleton-loader me-2" 
                          style={{
                            width: '16px',
                            height: '16px',
                            borderRadius: '50%',
                            backgroundColor: '#dc3545',
                            animation: 'pulse 1.5s ease-in-out infinite'
                          }}
                        />
                        <span 
                          className="skeleton-text"
                          style={{
                            width: '80px',
                            height: '16px',
                            backgroundColor: '#dc3545',
                            borderRadius: '4px',
                            animation: 'pulse 1.5s ease-in-out infinite'
                          }}
                        />
                      </div>
                    ) : (
                      'Remove Banner'
                    )}
                  </button>
                )}
              </div>
            </div>
            
            {dashboardData.bannerLoading ? (
              <div className="text-center py-5">
                <div className="d-flex justify-content-center align-items-center flex-column">
                  <BallTriangle
                    height={50}
                    width={55}
                    radius={5}
                    color="#af3585"
                    ariaLabel="ball-triangle-loading"
                    wrapperClass=""
                    wrapperStyle=""
                    visible={true}
                  />
                  <p className="mt-3 mb-0" style={{ color: '#666', fontSize: '14px' }}>Loading banner...</p>
                </div>
              </div>
            ) : dashboardData.banner ? (
              <div className="text-center">
                <img
                  src={dashboardData.banner}
                  alt="Dashboard Banner"
                  className={`${styles.banner_img1}`}
                  style={{ 
                    width: '100%',
                    height: '152px',
                    borderRadius: '8px',
                    boxShadow: '0 2px 8px rgba(0,0,0,0.1)',
                    objectFit: 'cover',
                    objectPosition: 'center'
                  }}
                />
              </div>
            ) : (
              <div 
                className={`${styles.uploadArea}`}
                onClick={() => !isPending && document.getElementById('banner-upload').click()}
                onDragOver={handleDragOver}
                onDragLeave={handleDragLeave}
                onDrop={handleDrop}
                style={{
                  border: '2px dashed #ddd',
                  borderRadius: '8px',
                  padding: '40px 20px',
                  textAlign: 'center',
                  cursor: isPending ? 'not-allowed' : 'pointer',
                  backgroundColor: isPending ? '#f5f5f5' : '#fafafa',
                  transition: 'all 0.3s ease',
                  opacity: isPending ? 0.7 : 1
                }}
                onMouseEnter={(e) => {
                  if (!isPending) {
                    e.target.style.borderColor = '#af52de';
                    e.target.style.backgroundColor = '#f8f0ff';
                  }
                }}
                onMouseLeave={(e) => {
                  if (!isPending) {
                    e.target.style.borderColor = '#ddd';
                    e.target.style.backgroundColor = '#fafafa';
                  }
                }}
              >
                <div className="mb-3">
                  <svg width="48" height="48" viewBox="0 0 24 24" fill="none" xmlns="http://www.w3.org/2000/svg">
                    <path d="M18 10H16.74C16.4379 7.54425 14.9441 5.33505 12.8321 4.13561C10.7201 2.93617 8.18358 2.88418 6.03275 3.98875C3.88192 5.09332 2.27206 7.24312 2.04258 9.7373C1.8131 12.2315 2.99475 14.7003 5.39999 16.3C5.39999 16.3 5.39999 16.3 5.39999 16.3" stroke="#9CA3AF" strokeWidth="2" strokeLinecap="round" strokeLinejoin="round"/>
                    <path d="M12 16L16 12L12 8" stroke="#9CA3AF" strokeWidth="2" strokeLinecap="round" strokeLinejoin="round"/>
                    <path d="M16 12H8" stroke="#9CA3AF" strokeWidth="2" strokeLinecap="round" strokeLinejoin="round"/>
                  </svg>
                </div>
                <div>
                  <p className="mb-1" style={{ color: '#af52de', fontWeight: '500' }}>
                    Click to upload or drag and drop
                  </p>
                  <p className="mb-0" style={{ fontSize: '12px', color: '#666' }}>
                    PNG or JPG (max. 1074x152px)
                  </p>
                </div>
                <input
                  id="banner-upload"
                  type="file"
                  accept="image/*"
                  onChange={handleBannerUpload}
                  style={{ display: 'none' }}
                />
              </div>
            )}
          </div>
        </div>
        {/* Banner */}
        {/* <div style={{ overflow: 'hidden' }}>
          <Slider {...settings}>
            <div>
              <Typography variant="h3" className={`${styles.banner}`}>
                <img
                  src="/assets/icons/bannerImageOne.png"
                  className={`${styles.banner_img1}`}
                  alt=""
                />
              </Typography>
            </div>
            <div>
              <Typography variant="h3" className={`${styles.banner}`}>
                <img
                  src="/assets/icons/bannerImageTwo.png"
                  alt="logo"
                  className={`${styles.banner_img1}`}
                />
              </Typography>
            </div>
          </Slider>
        </div> */}
        {/* Banner */}
        <div className={`${styles.analytics} mt-4`}>
          <Filter1 />
          <div>
            <div className="row">
              <div className={`col-12 mb-2 pr-0`}>
                <div className={`${styles.card}`}>
                  <div className={`card-body`}>
                    <div className="d-flex justify-content-between">
                      <small>Total Sales</small>
                    </div>
                    <div className={`${styles.numbers}`}>
                      <div>
                        <span>
                          {Number(
                            dashboardData?.total_sales?.bold
                          ).toLocaleString()}
                        </span>
                        <small>
                          {' '}
                          from{' '}
                          {Number(
                            dashboardData?.total_sales?.small
                          ).toLocaleString()}
                        </small>
                      </div>
                      <div>
                        {Number(
                          dashboardData?.total_sales?.bold
                        ).toLocaleString() >=
                        Number(
                          dashboardData?.total_sales?.small
                        ).toLocaleString() ? (
                          <div className={styles.percent}>
                            <img src="/assets/icons/up.svg" alt="" />
                            <small className="pl-1">
                              {dashboardData?.total_sales
                                ? Number(
                                    dashboardData?.total_sales?.percentagDiff
                                  ).toLocaleString()
                                : 0}
                              %
                            </small>
                          </div>
                        ) : (
                          <div className={`${styles.percent2}`}>
                            <img src="/assets/icons/downr.svg" alt="" />
                            <small className="pl-1">
                              {dashboardData?.total_sales
                                ? Math.abs(
                                    dashboardData?.total_sales?.percentagDiff
                                  )
                                : 0}
                              %
                            </small>
                          </div>
                        )}
                      </div>
                    </div>
                  </div>
                </div>
              </div>
              {/* <div className={`col-6 mb-2`}>
                <div className={`${styles.card}`}>
                  <div className={`card-body`}>
                    <div className="d-flex justify-content-between">
                      <small>Total Visitors</small>
                    </div>
                    <div className={`${styles.numbers}`}>
                      <div>
                        <span>{Number(dashboardData?.total_visitors?.bold).toLocaleString()}</span>
                        <small> from {Number(dashboardData?.total_visitors?.small).toLocaleString()}</small>
                      </div>
                      <div>
                      {
                        Number(dashboardData?.total_visitors?.bold).toLocaleString() >=
                        Number(dashboardData?.total_visitors?.small).toLocaleString() ?
                        <div className={styles.percent}>
                          <img src="/assets/icons/up.svg" alt="" />
                          <small className="pl-1">
                            {
                              dashboardData?.total_visitors ?
                              Number(dashboardData?.total_visitors?.percentageDiff).toLocaleString() :
                              0
                            }%
                          </small>
                        </div>
                        :
                        <div className={`${styles.percent2}`}>
                          <img src="/assets/icons/downr.svg" alt="" />
                          <small className="pl-1">
                            {
                              dashboardData?.total_visitors ?
                              Math.abs(dashboardData?.total_visitors?.percentageDiff) :
                              0
                            }%
                          </small>
                        </div>
                      }
                      </div>

                    </div>

                  </div>

                </div>

              </div> */}
            </div>
            {/* <div className={`mt-3 mb-2`} >
              <div className={`${styles.card}`} >
                <div className={`card-body`}>
                  <div className="d-flex justify-content-between">
                    <small>Total Sales</small>

                  </div>
                  <div className={`${styles.numbers} mt-3`}>
                    <div>
                      <span>₦ {Number(dashboardData?.total_sales_count?.bold).toLocaleString()}</span>
                      <small> from ₦ {Number(dashboardData?.total_sales_count?.small).toLocaleString()}</small>
                    </div>
                    <div>
                    {
                        Number(dashboardData?.total_sales_count?.bold).toLocaleString() >=
                        Number(dashboardData?.total_sales_count?.small).toLocaleString() ?
                        <div className={styles.percent}>
                          <img src="/assets/icons/up.svg" alt="" />
                          <small className="pl-1">
                            {
                              dashboardData?.total_sales_count ?
                              Number(dashboardData?.total_sales_count?.percentagDiff).toLocaleString() :
                              0
                            }%
                          </small>
                        </div>
                        :
                        <div className={`${styles.percent2}`}>
                          <img src="/assets/icons/downr.svg" alt="" />
                          <small className="pl-1">
                            {
                              dashboardData?.total_sales_count ?
                              Math.abs(dashboardData?.total_sales_count?.percentagDiff) :
                              0
                            }%
                          </small>
                        </div>
                      }

                    </div>

                  </div>

                </div>

              </div>

            </div> */}
          </div>
          {/* <div>
            <div className={`${styles.card2} card    `} style={{ padding: '' }}>
              <div className={`${styles.wallet}`}  >
                <img className={`${styles.img} ${styles.img1}`} src="/assets/crc.png" alt="" />
                <div className={`${styles.content}`}>
                  <div className={`${styles.content_header}`}>
                    <div>
                      ₦‎ {Number(dashboardData?.wallet_info?.balance?.$numberDecimal).toLocaleString() + '.00'}

                    </div>
                    <div>
                      <img src="/assets/icons/Vector.svg" alt="" />
                    </div>

                  </div>
                  <p className={`${styles.sub_text}`}>
                    Your Balance
                  </p>
                  <div className={`${styles.content_body} ${styles.content_body2}`}>
                    <p className={`${styles.sub_text}`}>
                      Account Details
                    </p>

                    <div className={`${styles.bank_info}`}>
                      <div >
                        <p className={`${styles.name}`}>
                          {dashboardData?.wallet_info?.brand_id?.bank_account_name}

                        </p>
                        <p className={`${styles.account_number}`}>
                          {dashboardData?.wallet_info?.brand_id?.bank_account_number}
                        </p>

                      </div>
                      <img className="mt-2" src="/assets/Logomark.svg" alt="" />
                      <span style={{
                          fontSize:'9px',
                          fontWeight:'700',
                          color:'#FFFFFF'
                        }}>
                          {dashboardData?.wallet_info?.brand_id?.bank_name}
                      </span>
                    </div>
                  </div>
                </div>
                <div className={`${styles.footer} ${styles.footer2}`}>
                  <div className="">
                    <p className="mb-0 pb-0">
                      <RouterLink to="/app/wallets">
                        Manage Wallet
                        <img src="/assets/icons/arrow-right.svg" alt="" />
                        &nbsp;

                      </RouterLink>


                    </p>

                  </div>

                </div>

              </div>

            </div>
          </div> */}
        </div>

        <Card
          style={{ marginTop: '50px', borderRadius: '10px' }}
          className="p-0"
        >
          <div className="p-3 ">
            <h5 className="table_desc_header">Recent Sales</h5>
            <div
              style={{
                display: 'flex',
                justifyContent: 'space-between',
              }}
            >
              <small style={{ fontWeight: '200', fontSize: '12px' }}>
                {dataFilter === 'today'
                  ? // `Orders made for Today`
                    `A record of all recent sales`
                  : dataFilter === 'alltime'
                  ? `A record of all recent sales`
                  : dataFilter === 'pastweek'
                  ? `Orders made for the Past Week`
                  : ` Orders made in the last ${dataFilter} `}
              </small>
              {/* <small style={{ color: '#af3585', cursor: 'pointer' }} onClick={() => navigateTo()}>
                View all <img src="/assets/icons/arrow-righty.svg" alt="" />
              </small> */}
            </div>
          </div>
          <Scrollbar>
            <div className={`table-responsive-sm pt-3 pb-3 pl-0 pr-0`}>
              <table className={`${styles.table} table-hover table-striped`}>
                <thead className={`${styles.thead}`}>
                  <tr>
                    {TABLE_HEAD.map((el, i) => {
                      let sIndex = i < 1 ? 1 : false;

                      return (
                        <th key={i} className="text-muted">
                          {el.label}{' '}
                          {sIndex && (
                            <span style={{ cursor: 'pointer' }}>
                              <img
                                className="pl-2"
                                src="/assets/icons/down.svg"
                                alt=""
                              />
                            </span>
                          )}
                        </th>
                      );
                    })}
                  </tr>
                </thead>
                <tbody>
                  {!isPending &&
                    dashboardData?.recent_sales?.length > 0 &&
                    dashboardData?.recent_sales?.slice(0, 6).map((el, i) => {
                      return (
                        <tr className={`${styles.tr}`} key={i}>
                          <td>
                            <div className=" ">
                              <div
                                style={{
                                  display: 'flex',
                                  flexDirection: 'row',
                                  alignItems: 'center',
                                }}
                              >
                                <Avatar
                                  className={`${styles.avatrr} mr-3`}
                                  alt={el?.user_info?.store_name}
                                  src={el?.user_info?.store_logo}
                                  style={{ width: '50px', height: '50px' }}
                                />
                                <div>
                                  <p
                                    className="mb-0"
                                    style={{ fontSize: '14px' }}
                                  >
                                    <strong>{el?.user_info?.user_name}</strong>
                                  </p>
                                  <span style={{ fontSize: '10px' }}>
                                    {el?.user_info?.user_email}
                                  </span>
                                </div>
                              </div>
                            </div>
                          </td>
                          <td>
                            <p>{el?.order_number}</p>
                          </td>
                          <td>
                            <p className="text-center">
                              <BootstrapTooltip
                                title={
                                  <div>
                                    {!tooltipLoading &&
                                      tooltipData.product_items.length > 0 &&
                                      tooltipData.product_items.map(
                                        (tooltip, ind) => (
                                          <span key={ind} className="mr-1">
                                            {tooltip.product_name},
                                          </span>
                                        )
                                      )}
                                    {!tooltipLoading &&
                                      tooltipData.product_items.length < 1 && (
                                        <span>Empty</span>
                                      )}
                                    {tooltipLoading && <span>Loading</span>}
                                  </div>
                                }
                              >
                                <span
                                  style={{ cursor: 'pointer' }}
                                  onMouseEnter={() =>
                                    getHoverProduct(el._id._id)
                                  }
                                >
                                  {el?.product_unit}
                                </span>
                              </BootstrapTooltip>
                            </p>
                          </td>
                          <td>
                            <BootstrapTooltip title={<div>{el?.location}</div>}>
                              <p>
                                {el?.location
                                  ? shortenText(el?.location)
                                  : '---'}
                              </p>
                            </BootstrapTooltip>
                          </td>
                          <td>
                            <p>
                              <span
                                className={`${
                                  el?.status === 'completed'
                                    ? styles.customer
                                    : el?.status === 'pending'
                                    ? styles.pending
                                    : el?.status === 'refunded'
                                    ? styles.refunded
                                    : styles.abandoned
                                }`}
                              >
                                {el?.status}
                              </span>
                            </p>
                          </td>
                          <td>
                            <p>
                              {moment(el?.date_ordered).format('DD/MM/YYYY')}
                            </p>
                          </td>
                        </tr>
                      );
                    })}
                </tbody>
              </table>
            </div>
            <div className="d-flex justify-content-center">
              {isPending && (
                <BallTriangle
                  height={50}
                  width={55}
                  radius={5}
                  color="#af3585"
                  ariaLabel="ball-triangle-loading"
                  wrapperClass={{}}
                  wrapperStyle=""
                  visible={true}
                />
              )}
            </div>
            {!dashboardData?.recent_sales?.length && !isPending && (
              <div className="alert alert-[#af3585] text-center">
                <h4>No record found</h4>
              </div>
            )}
          </Scrollbar>
        </Card>
      </div>
    </>
  );
}